import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import BusinessOverview from 'src/sections/overview/dashboards/views/businessOverview';

export default function SearchPerformanceOverview() {
  return (
    <>
      <Helmet>
        <title>Search Performance</title>
      </Helmet>

      {/* Breathing room between the (taller) fixed filter bar and the KPI cards. */}
      <Box sx={{ pt: 1.5 }}>
        <BusinessOverview />
      </Box>
    </>
  );
}
